import { constants } from '@bedc/constants';

import { Request } from '../../../../api/admin/client/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const ResourceAdminType = SearchDataTableType({
	request: Request,
	columnFields: constants.client.search.adminColumnFields,
	filterIds: constants.client.search.adminStandardFilterFields,
});
